import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";

import { getDining } from "../store/feature/restaurantSlice";
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FooterMobileMenu from '../components/FooterMobileMenu';
import { Link } from 'react-router-dom';
import restImage from '../assets/diningBackground.jpg'
import { Helmet } from 'react-helmet';
import DiningRestro from './DiningRestro';
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Dining = () => {
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedGuests, setSelectedGuests] = useState("2");
  const [searchText, setSearchText] = useState("");

  const [filteredRestaurants, setFilteredRestaurants] = useState([]);

  const formatDateForAPI = (date) => {
    if (!date) return "";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const times = getAvailableTimes();

    if (times.length > 0 && !selectedTime) {
      setSelectedTime(times[0].value);
    }
  }, [selectedDate]);

  useEffect(() => {
    fetchDiningRestaurants();
  }, [selectedDate, selectedTime, selectedGuests]);

  const fetchDiningRestaurants = async () => {

    try {

      const payload = {
        Date: formatDateForAPI(selectedDate),
        Time: selectedTime || "",
        Location: "",
        TotalPerson: parseInt(selectedGuests)
      };

      console.log("Dining Search Payload:", payload);

      const response = await axios.get(
        "https://highwycombebites.com/api/restaurantmaster/GetDiningRestaurants",
        {
          params: payload   // ✅ QUERY PARAMS
        }
      );

      if (response.data?.success === "1") {
        setRestaurants(response.data.data || []);
      }

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    let filtered = [...restaurants];

    if (searchText) {
      filtered = filtered.filter((rest) =>
        rest.name.toLowerCase().includes(searchText.toLowerCase()) ||
        rest.cuisine?.toLowerCase().includes(searchText.toLowerCase()) ||
        rest.location?.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    if (selectedGuests) {
      filtered = filtered.filter((rest) => {
        if (!rest.tables) return true;
        try {
          const tables = JSON.parse(rest.tables);
          return tables.some(
            (table) =>
              table.isactive &&
              table.guestcapicity >= parseInt(selectedGuests)
          );
        } catch {
          return true;
        }
      });
    }

    if (selectedDate && selectedTime) {
      const selectedDay = new Date(selectedDate).toLocaleString("en-US", {
        weekday: "long",
      });

      filtered = filtered.filter((rest) => {
        if (!rest.dailytiming) return true;

        const dayTiming = rest.dailytiming.find(
          (d) => d.day === selectedDay && d.closed === "0"
        );

        if (!dayTiming) return false;

        const start = dayTiming.starttime;
        const end = dayTiming.endtime;

        return true;
      });
    }

    setFilteredRestaurants(filtered);
  };

  const getAvailableTimes = () => {

    const times = [];

    const now = new Date();

    const isToday =
      selectedDate &&
      new Date(selectedDate).toDateString() === now.toDateString();

    for (let index = 0; index < 48; index++) {

      const hours = Math.floor(index / 2);
      const minutes = index % 2 === 0 ? "00" : "30";

      const hour24 = hours.toString().padStart(2, "0");
      const timeValue = `${hour24}:${minutes}`;

      if (isToday) {

        const slotDate = new Date();
        slotDate.setHours(hours, minutes, 0);

        if (slotDate <= now) continue;
      }

      const hour12 = hours % 12 === 0 ? 12 : hours % 12;
      const ampm = hours < 12 ? "AM" : "PM";

      times.push({
        value: timeValue,
        label: `${hour12}:${minutes} ${ampm}`
      });
    }

    return times;
  };

  useEffect(() => {
    setSelectedTime("");
  }, [selectedDate]);

  return (
    <>
      <Helmet>
        <title>Book a Table in High Wycombe | Top Local Restaurants</title>
        <meta
          name="description"
          content="Discover and book tables at the best restaurants in High Wycombe through High Wycombe Bites."
        />
      </Helmet>
      <Navbar />
      <section className="section-t-space mytabb overflow-hidden pt-120">
        <div className="container text-center">
          <div className="tab">
            <div>
              <Link className="tablinks active">
                <p>
                  <i className="fa fa-motorcycle" /> Delivery
                </p>{" "}
                <p className="smtext">35 - 50 Min</p>
              </Link>
              <Link className="tablinks">
                <p>
                  <i className="fa fa-shopping-bag" aria-hidden="true" /> Collection{" "}
                </p>{" "}
                <p className="smtext">15 - 25 Min</p>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section
        className="page-head-section"
        style={{
          position: 'relative',
          padding: '145px 0px 100px 0px',
          backgroundColor: '#00000085',
          backgroundImage: `url(${restImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >

        <div className="container page-heading">
          <h2 className="h3 mb-3 text-white text-center">Dining</h2>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb flex-lg-nowrap justify-content-center justify-content-lg-star">
              <li className="breadcrumb-item">
                <Link to="/">
                  <i className="ri-home-line" />
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
               > Dining
              </li>
            </ol>
          </nav>
        </div>
      </section>

      <section className="restaurant-list pt-0 mt-5">
        <div className="container">
          <div
            style={{
              background: "#ffffff",
              borderRadius: "18px",
              padding: "20px",
              boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
            }}
          >
            <div
              className="row"
              style={{ rowGap: "16px", alignItems: "center" }}
            >

              {/* Date */}
              <div className="col-12 col-md-3">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #e5e7eb",
                    borderRadius: "14px",
                    padding: "10px 14px",
                    height: "48px",
                  }}
                >
                  <i
                    className="bi bi-calendar-event"
                    style={{
                      fontSize: "18px",
                      color: "#6b7280",
                      marginRight: "10px",
                    }}
                  ></i>
                  {/* <input
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    style={{
                      border: "none",
                      outline: "none",
                      width: "100%",
                      fontSize: "14px",
                      background: "transparent",
                    }}
                  /> */}
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    dateFormat="dd-MM-yyyy"
                    minDate={new Date()}
                    placeholderText="Select Date"
                    className="custom-date-input"
                  />
                </div>
              </div>

              {/* Time */}
              <div className="col-12 col-md-2">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #e5e7eb",
                    borderRadius: "14px",
                    padding: "10px 14px",
                    height: "48px",
                  }}
                >
                  <i
                    className="bi bi-clock"
                    style={{
                      fontSize: "18px",
                      color: "#6b7280",
                      marginRight: "10px",
                    }}
                  ></i>
                  {/* <select
                    value={selectedTime}
                    onChange={(e) => setSelectedTime(e.target.value)}
                    style={{
                      border: "none",
                      outline: "none",
                      width: "100%",
                      fontSize: "14px",
                      background: "transparent",
                    }}
                  >
                    <option value="">Select Time</option>

                    {Array.from({ length: 48 }).map((_, index) => {
                      const hours = Math.floor(index / 2);
                      const minutes = index % 2 === 0 ? "00" : "30";

                      const hour24 = hours.toString().padStart(2, "0");
                      const timeValue = `${hour24}:${minutes}`;

                      // Convert to 12 hour format for display
                      const hour12 = hours % 12 === 0 ? 12 : hours % 12;
                      const ampm = hours < 12 ? "AM" : "PM";

                      const displayTime = `${hour12}:${minutes} ${ampm}`;

                      return (
                        <option key={timeValue} value={timeValue}>
                          {displayTime}
                        </option>
                      );
                    })}
                  </select> */}
                  <select
                    value={selectedTime}
                    onChange={(e) => setSelectedTime(e.target.value)}
                    style={{
                      border: "none",
                      outline: "none",
                      width: "100%",
                      fontSize: "14px",
                      background: "transparent",
                    }}
                  >
                    <option value="">Select Time</option>

                    {getAvailableTimes().map((time) => (
                      <option key={time.value} value={time.value}>
                        {time.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Guests */}
              <div className="col-12 col-md-2">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #e5e7eb",
                    borderRadius: "14px",
                    padding: "10px 14px",
                    height: "48px",
                  }}
                >
                  <i
                    className="bi bi-people"
                    style={{
                      fontSize: "18px",
                      color: "#6b7280",
                      marginRight: "10px",
                    }}
                  ></i>
                  <select
                    value={selectedGuests}
                    onChange={(e) => setSelectedGuests(e.target.value)}
                    style={{
                      border: "none",
                      outline: "none",
                      width: "100%",
                      fontSize: "14px",
                      background: "transparent",
                    }}
                  >
                    {[1, 2, 3, 4, 5, 6, 7, 8].map(num => (
                      <option key={num} value={num}>
                        {num} {num === 1 ? "person" : "people"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>


              {/* Search */}
              <div className="col-12 col-md-3">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #e5e7eb",
                    borderRadius: "14px",
                    padding: "10px 14px",
                    height: "48px",
                  }}
                >
                  <i
                    className="bi bi-search"
                    style={{
                      fontSize: "18px",
                      color: "#6b7280",
                      marginRight: "10px",
                    }}
                  ></i>
                  <input
                    type="text"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Restaurant, cuisine or location"
                    style={{
                      border: "none",
                      outline: "none",
                      width: "100%",
                      fontSize: "14px",
                    }}
                  />
                </div>
              </div>

              {/* Button */}
              <div className="col-12 col-md-2">
                <button
                  style={{
                    width: "100%",
                    height: "48px",
                    borderRadius: "14px",
                    border: "none",
                    backgroundColor: "#019ee3",
                    color: "#ffffff",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#0185c0")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#019ee3")
                  }
                  onClick={handleSearch}
                >
                  Go
                  <i
                    className="bi bi-arrow-right-short"
                    style={{ fontSize: "22px" }}
                  ></i>
                </button>
              </div>

            </div>
          </div>
        </div>
      </section>

      <div className="container">
        {loading ? (
          <p className="text-center">Loading restaurants...</p>
        ) : (
          // <DiningRestro restaurants={restaurants} />
          // <DiningRestro
          //   restaurants={
          //     filteredRestaurants.length > 0 || searchText
          //       ? filteredRestaurants
          //       : restaurants
          //   }
          // />
          <DiningRestro
            restaurants={restaurants}
            selectedDate={formatDateForAPI(selectedDate)}
            selectedTime={selectedTime}
            selectedGuests={selectedGuests}
          />
        )}
      </div>

      <section className="intro-text section-a-space">
        <div className="container d-flex flex-column align-items-center text-center">
          <p>
            <h2 className='mb-4 mt-4'>Discover The Best Restaurants in High Wycombe!</h2>
            We bring you an innovative dining experience
            that not only connects you with top local eateries
            but also helps restaurants f-<strong>he Early Bird Deal,
              you can save up to 25% on your food bill when
              you book early</strong>. It’s a win-win for foodies and
            restaurants alike! Whether you’re planning a casual meal
            or a special dinner, High Wycombe Bites makes it easy to
            reserve a table while enjoying exclusive discounts. Support local
            businesses, explore new flavors, and be part of strengthening our community through smarter dining choices
          </p>
        </div>

      </section>

      <Footer />
      <FooterMobileMenu selected={"Dining"} />
      <div
        className="modal fade location-modal"
        id="location"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">
                <h5 className="fw-semibold">Select a Location</h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
            </div>
            <div className="modal-body">
              <div className="search-section">
                <form className="form_search" role="form">
                  <input
                    type="search"
                    placeholder="Search Location"
                    className="nav-search nav-search-field"
                  />
                </form>
              </div>
              <Link href="" className="current-location">
                <div className="current-address">
                  <i className="ri-focus-3-line focus" />
                  <div>
                    <h5>Use current-location</h5>
                    <h6>Wellington St., Ottawa, Ontario, Canada</h6>
                  </div>
                </div>
                <i className="ri-arrow-right-s-line arrow" />
              </Link>
              <h5 className="mt-sm-3 mt-2 fw-medium recent-title dark-text">
                Recent Location
              </h5>
              <Link href="" className="recent-location">
                <div className="recant-address">
                  <i className="ri-map-pin-line theme-color" />
                  <div>
                    <h5>Bayshore</h5>
                    <h6>kingston St., Ottawa, Ontario, Canada</h6>
                  </div>
                </div>
              </Link>
            </div>
            <div className="modal-footer">
              <Link href="#" className="btn gray-btn" data-bs-dismiss="modal">
                Close
              </Link>
              <Link href="#" className="btn theme-btn mt-0" data-bs-dismiss="modal">
                Save
              </Link>
            </div>
          </div>
        </div>
      </div>
      <button className="scroll scroll-to-top menu-page">
        <i className="ri-arrow-up-s-line arrow" />
      </button>
    </>
  )
}

export default Dining